import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ParticipantDetailsPage, { getDefaultData } from "components/pages/ParticipantDetailsPage";
import Classes from "model";

export default function CaptureParticipantDetailsNameEntered(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "participant", "participantName" ], "Thomas Jefferson")
    .submit();
    return <ParticipantDetailsPage data={ data } />
}